import "../../nexus-client-4D0Jw00_.js";
import { benefit as t } from "../index.js";
const i = t.bounce, e = i.init;
export {
  i as benefitBounce,
  e as init
};
/*                             */
